import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Report from '../../../Report/Report';

export function DashboardTable({ headerName, data, metrics, loading, getLastData, clear }) {
    useEffect(() => {
        getLastData();
        return () => {
            clear();
        };
    }, [getLastData, clear]);

    return (
        <Report
            headerName={headerName}
            data={data}
            tableHtml={data}
            metrics={metrics}
            isTableLast={true}
            loading={loading}
            tableWrapperClass={{
                'dashboard-table-wrapper': true,
                'table-responsive_compact-report': true,
                'table-responsive_compact-report_dashboard': true
            }}
        />
    );
}

DashboardTable.propTypes = {
    headerName: PropTypes.any,
    data: PropTypes.string,
    metrics: PropTypes.any,
    loading: PropTypes.bool,
    getLastData: PropTypes.func.isRequired,
    clear: PropTypes.func.isRequired
};

DashboardTable.defaultProps = {
    data: '',
    loading: false
};

export default DashboardTable;
